// Mock data for initial development
const mockAchievements = [
  { id: 1, title: 'Years of Excellence', value: '25+', description: 'Serving the gold industry' },
  { id: 2, title: 'Happy Clients', value: '1000+', description: 'Trusted by wholesalers' },
  { id: 3, title: 'Gold Products', value: '500+', description: 'Wide range of products' },
];

const mockPartners = [
  { id: 1, name: 'Partner 1', logo: 'https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.goodreturns.in%2Fpersonal-finance%2Finvestment%2Ftop-7-popular-gold-gems-and-jewellary-company-stocks-in-india-1226513.html&psig=AOvVaw01uvBGYjVxeGhY8Gt5DWmy&ust=1743677246723000&source=images&cd=vfe&opi=89978449&ved=0CBEQjRxqFwoTCMD3iouWuYwDFQAAAAAdAAAAABAI' },
  { id: 2, name: 'Partner 2', logo: '/partner2.png' },
  { id: 3, name: 'Partner 3', logo: '/partner3.png' },
];

const mockTeam = [
  { id: 1, name: 'John Doe', position: 'CEO', image: '/team1.png' },
  { id: 2, name: 'Jane Smith', position: 'Operations Head', image: '/team2.png' },
  { id: 3, name: 'Mike Johnson', position: 'Technical Director', image: '/team3.png' },
];

// Simulated API calls
export const fetchHomeData = async () => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  return {
    achievements: mockAchievements,
    partners: mockPartners,
    team: mockTeam,
  };
}; 